import { BaseViewStore } from 'core/stores';
import { ApplicationStore } from 'platform/application/stores';
import { WarehouseOrganizationInfoStore } from 'modules/warehouse/stores';
import { localStorageHandler } from 'core/services';
import { CloseOutPalletizingForm } from 'modules/order/forms';
import { notificationError, isSome } from 'core/utils';
import { observable, action, makeObservable } from 'mobx';
import { sourceOfChange } from 'common/constants';
import _ from 'lodash';

class CloseOutPalletizingViewStore extends BaseViewStore {
	@observable disableSaveBtn = true;
	@observable warehouseOptions = [];
	@observable responseArray = [];
	@observable isWarehouseDropdownLoading = false;

	debouncedOnCheck = null;
	debouncedWarehouseSearch = null;

	form = new CloseOutPalletizingForm({
		onSuccess: () => {
			this.CloseOutPalletizing;
		},
	});

	constructor(rootStore) {
		super(rootStore);
		makeObservable(this);
		this.applicationStore = new ApplicationStore(rootStore);
		this.warehouseOrganizationInfoStore = new WarehouseOrganizationInfoStore(rootStore);
		this.initialize();
	}

	@action.bound async initialize() {
		this.suspend();
		this.form.state.options.set({
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: false,
		});
		this.debouncedWarehouseSearch = _.debounce((searchPhrase, { action }) => {
			this.searchWarehouseAsync(searchPhrase, { action });
		}, 500);

		await this.getWarehouseOptions();
		this.resume();
	}

	@action.bound
	handleOnWarehouseMenuScroll = async () => {
		if (this.warehouseOptions.length < this.pageWarehouse * 15) return;
		this.isWarehouseDropdownLoading = true;
		this.pageWarehouse++;

		await this.applicationStore.find({
			rpp: 15,
			page: this.pageWarehouse,
			warehouseOnly: true,
			isOrganizationActive: true,
		});
		this.responseArray = [...this.responseArray, ...this.applicationStore.response.item];
		const newOptions = _.map(this.responseArray, item => {
			return { value: item.id, label: item.applicationTitle };
		});
		if (newOptions.length > this.warehouseOptions.length) {
			this.warehouseOptions = [...newOptions];
		}
		this.isWarehouseDropdownLoading = false;
	};

	@action.bound
	async searchWarehouseAsync(searchPhrase, { action }) {
		if (searchPhrase === '') {
			this.pageWarehouse = 1;
		}
		if (action === 'input-change') {
			this.isWarehouseDropdownLoading = true;
			this.infiniteSearchPhrase = searchPhrase;
			this.pageWarehouse = 1;
			this.warehouseOptions = [];
			let filter = {
				search: searchPhrase || null,
				rpp: 15,
				page: 1,
				warehouseOnly: true,
				isOrganizationActive: true,
			};
			await this.applicationStore.find(filter);
			this.responseArray = [...this.applicationStore.response.item];
			const newOptions = [];
			_.forEach(this.responseArray, item => {
				newOptions.push({ value: item.id, label: item.applicationTitle, extra: item });
			});
			this.warehouseOptions = newOptions;
			this.isWarehouseDropdownLoading = false;
		}
	}

	@action.bound
	async onMenuClose() {
		this.pageWarehouse = 1;
		this.infiniteSearchPhrase = null;
		await this.getWarehouseOptions(false);
	}

	@action.bound async getWarehouseOptions() {
		this.pageWarehouse = 1;
		await this.applicationStore.find({
			page: this.pageWarehouse,
			rpp: 15,
			warehouseOnly: true,
			isOrganizationActive: true,
			useSafeQuantity: false,
		});
		this.responseArray = [...this.applicationStore.response.item];
		this.warehouseOptions = _.map(this.responseArray, item => {
			return { label: item.applicationTitle, value: item.id, extra: item };
		});
	}

	@action.bound
	async closeOutPalletizing() {
		this.suspend();
		try {
			const response = await this.warehouseOrganizationInfoStore.closeOutPalletizing(
				sourceOfChange.closeOutPalletizing,
				this.form.$('warehouse').value.value
			);
			if (response) {
				this.rootStore.notificationStore.success('WAREHOUSEVIEW.CLOSEOUT.PALLETIZING.SUCCESS');
			} else {
				this.rootStore.notificationStore.error('WAREHOUSEVIEW.CLOSEOUT.PALLETIZING.FAILURE');
				this.setCloseOutFlag(true);
				this.setCloseOutWarehouse(this.form.$('warehouse').value);
				this.rootStore.routerStore.goTo('master.app.main.order.closeout.detail');
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.resume();
	}

	onWarehouseSelect = async item => {
		this.form.$('warehouse').value = item;
		await this.getWarehouseOptions(false);
		this.disableSaveBtn = false;
	};

	setCloseOutFlag = flag => {
		localStorageHandler.set('isCloseOutPalletizing', flag);
	};

	setCloseOutWarehouse = warehouse => {
		localStorageHandler.set('closeOutWarehouse', warehouse);
	};
}

export default CloseOutPalletizingViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/CloseOutPalletizingViewStore.js